import { useDispatch, useSelector } from 'react-redux'
import { selectTranslations } from '../../../services/i18n/i18nSlice'
import { useState } from 'react';

import trash_img from '../../../assets/images/trash.svg'
import add_img from '../../../assets/images/add.svg'


import ConfirmModal from '../../../components/_modals/ConfirmModal';
import EditableInput from '../../../components/_form/EditableInput';
import { Form, InputGroup } from 'react-bootstrap';

import correct_img from '../../../assets/images/questions/correct.svg'
import wrong_img from '../../../assets/images/questions/wrong.svg'
import missing_img from '../../../assets/images/questions/missing.svg'


export default function ExamModules (props) {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()

    const [showUploadModal, setShopUploadModal] = useState(false)
    const [confirmModal, setConfirmModal] = useState({
        title: "",
        text: "",
        onClose: null,
        onConfirm: null,
        confirmCta: "",
        closeCta: ""
    })


    const handleUpdateModuleData = (e, index) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        let _modules = structuredClone(props.examData?.modules)
        _modules[index]={
            ..._modules[index],
            [name]: value
        }
        props.onExamDataChange({
            ...props.examData,
            modules: _modules
        })
    }

    const addThreshold = (index) => {
        let _modules = structuredClone(props.examData?.modules)
        _modules[index]={
            ..._modules[index],
            thresholds: [..._modules[index]?.thresholds || [], {
                threshold_name: "",
                is_showable: true,
                score: 0,
                threshold_type: "standard_threshold"
            }]
        }
        props.onExamDataChange({
            ...props.examData,
            modules: _modules
        })
    }

    const removeThreshold = (index, index_treshhold) => {
        let _modules = structuredClone(props.examData?.modules)
        let _thresholds = _modules[index]?.thresholds
        _thresholds.splice(index_treshhold, 1)
        props.onExamDataChange({
            ...props.examData,
            modules: _modules
        })
    }

    const handleUpdateThresholdsData = (e, index, index_treshhold) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        let _modules = structuredClone(props.examData?.modules)
        let _thresholds = _modules[index]?.thresholds
        _thresholds[index_treshhold]={
            ..._thresholds[index_treshhold],
            [name]: value
        }
        props.onExamDataChange({
            ...props.examData,
            modules: _modules
        })
    }
 

    return (
        <>

            { props.examData?.modules && props.examData?.modules?.length > 0  ?
            <div>
                {
                    props.examData?.modules?.map((module,index)=>{
                        return(
                            <div key={index} className='questions_module' id={`module_${index}`}>
                                <div className='d-flex justify-content-between'>   
                                    <h3>{module.module_name || (props.examData.modules.length > 1 ? t.question.new_module : t.question.all_the_questions)} </h3> 
                                </div>
                                <Form.Group controlId="description" className='mb-2'>
                                    <Form.Label>{t.exam.description}</Form.Label>
                                    <Form.Control className='' type="text" value={module.description || ''} name="description" onChange={(e)=>handleUpdateModuleData(e,index)} />
                                </Form.Group>
                                <div className='row'>
                                    <div className='col-9'>
                                        <Form.Label >{t.exam.answer_points}</Form.Label>
                                        <div className='row'>
                                            <div className='col-4 d-flex align-items-center'>
                                                <img src={correct_img} alt='' />
                                                <span>Corrette</span>
                                                <InputGroup >
                                                    <Form.Control className='minw-0 ms-2' type="number" value={props.examData?.modules[index]?.correct_answer_score || ''} name="correct_answer_score" onChange={(e)=>handleUpdateModuleData(e,index)} />
                                                    <InputGroup.Text>pt</InputGroup.Text>
                                                </InputGroup>
                                            </div>
                                            <div className='col-4 d-flex align-items-center'>
                                                <img src={missing_img} alt='' />
                                                <span>Omesse</span>
                                                <InputGroup >
                                                    <Form.Control className='minw-0 ms-2' type="number" value={props.examData?.modules[index]?.omitted_answer_score || ''} name="omitted_answer_score" onChange={(e)=>handleUpdateModuleData(e,index)} />
                                                    <InputGroup.Text>pt</InputGroup.Text>
                                                </InputGroup>
                                            </div>
                                            <div className='col-4 d-flex align-items-center'>
                                                <img src={wrong_img} alt='' />
                                                <span>Sbagliate</span>
                                                <InputGroup >
                                                    <Form.Control className='minw-0 ms-2' type="number" value={props.examData?.modules[index]?.wrong_answer_score || ''} name="wrong_answer_score" onChange={(e)=>handleUpdateModuleData(e,index)} />
                                                    <InputGroup.Text>pt</InputGroup.Text>
                                                </InputGroup>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        props.examData.time === null ?
                                        <div className='col-3'>
                                            <Form.Label >{t.exam.time}</Form.Label>
                                            <InputGroup >
                                                <Form.Control className='minw-0' type="number" value={props.examData?.modules[index]?.time || ''} name="time" onChange={(e)=>handleUpdateModuleData(e,index)} />
                                                <InputGroup.Text>min</InputGroup.Text>
                                            </InputGroup>
                                        </div> : null
                                    }
                                </div>    
                                <div className='row mt-3'>
                                    <div className='d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom'>
                                        <h3>{t.exam.treshholds}</h3>
                                        <button onClick={()=>addThreshold(index)}>
                                            <img src={add_img} alt='' />
                                            {t.exam.add_threshold}
                                        </button>
                                    </div>
                                    {
                                        module?.thresholds?.map((treshhold, index_treshhold)=>{
                                            return(
                                                <div className='d-flex align-items-center mb-2 pb-2 border-bottom flex-wrap'>
                                                    <Form.Group controlId="description" className=''>
                                                        <Form.Label>{t.exam.name}</Form.Label>
                                                        <Form.Control className='' type="text" value={treshhold.threshold_name || ''} name="threshold_name" onChange={(e)=>handleUpdateThresholdsData(e,index,index_treshhold)} />
                                                    </Form.Group>
                                                    <Form.Group controlId="description" className='ms-2'>
                                                        <Form.Label>{t.exam.points_to_get}</Form.Label>
                                                        <InputGroup >
                                                            <Form.Control className='minw-0 ms-2' type="number" value={treshhold.score || ''} name="score" onChange={(e)=>handleUpdateThresholdsData(e,index,index_treshhold)} />
                                                            <InputGroup.Text>pt</InputGroup.Text>
                                                        </InputGroup>
                                                    </Form.Group>
                                                    <Form.Group controlId="type" className='ms-2'>
                                                        <Form.Label>{t.exam.threshold_type}</Form.Label>
                                                    <Form.Select value={treshhold.threshold_type} style={{maxWidth:'25%'}} name='threshold_type' onChange={(e)=>handleUpdateThresholdsData(e,index,index_treshhold)}>
                                                        <option disabled>Seleziona</option>
                                                        <option value="standard_threshold">Standard</option>
                                                        <option value="certificate_generation">Generazione Certificato</option>
                                                        <option value="esse3_passing_score_threshold">ESSE3 - Soglia superamento</option>
                                                        <option value="esse3_add_to_libretto_threshold">ESSE3 - Aggiungi a libretto</option>
                                                        <option value="subject_passing_score_threshold">Soglia superamento per materia</option>
                                                        <option value="add_to_group_threshold">Aggiungi al gruppo</option>
                                                    </Form.Select>
                                                    </Form.Group>
                                                <Form.Group controlId={'is_showable'} className='ms-2 d-flex align-items-center'>
                                                    <Form.Check
                                                        type='switch'
                                                        id={`is_showable_${index}_${index_treshhold}`}
                                                        name='is_showable'
                                                        label={'Mostrabile'}
                                                        onChange={(e)=>handleUpdateThresholdsData(e,index,index_treshhold)}
                                                        checked={treshhold?.is_showable || false}
                                                    />
                                                </Form.Group>
                                                {
                                                    treshhold.threshold_type === 'esse3_passing_score_threshold' ? (
                                                        <Form.Group controlId='ad_cod' className='ms-2'>
                                                            <Form.Label>AD COD</Form.Label>
                                                            <Form.Control className='' type='text' value={treshhold.ad_cod || ''} name='ad_cod' onChange={(e)=>handleUpdateThresholdsData(e,index,index_treshhold)} />
                                                        </Form.Group>
                                                    ) : null
                                                }
                                                {
                                                    treshhold.threshold_type === 'esse3_add_to_libretto_threshold' ? (
                                                        <>
                                                            <Form.Group controlId='ad_cod' className='ms-2'>
                                                                <Form.Label>AD COD</Form.Label>
                                                                <Form.Control className='' type='text' value={treshhold.ad_cod || ''} name='ad_cod' onChange={(e)=>handleUpdateThresholdsData(e,index,index_treshhold)} />
                                                            </Form.Group>
                                                            <Form.Group controlId='ad_des' className='ms-2'>
                                                                <Form.Label>AD DES</Form.Label>
                                                                <Form.Control className='' type='text' value={treshhold.ad_des || ''} name='ad_des' onChange={(e)=>handleUpdateThresholdsData(e,index,index_treshhold)} />
                                                            </Form.Group>
                                                            <Form.Group controlId='cds_id' className='ms-2'>
                                                                <Form.Label>CDS ID</Form.Label>
                                                                <Form.Control className='' type='number' value={treshhold.cds_id || ''} name='cds_id' onChange={(e)=>handleUpdateThresholdsData(e,index,index_treshhold)} />
                                                            </Form.Group>
                                                            <Form.Group controlId='cds_cod' className='ms-2'>
                                                                <Form.Label>CDS COD</Form.Label>
                                                                <Form.Control className='' type='text' value={treshhold.cds_cod || ''} name='cds_cod' onChange={(e)=>handleUpdateThresholdsData(e,index,index_treshhold)} />
                                                            </Form.Group>
                                                            <Form.Group controlId='pds_id' className='ms-2'>
                                                                <Form.Label>PDS ID</Form.Label>
                                                                <Form.Control className='' type='number' value={treshhold.pds_id || ''} name='pds_id' onChange={(e)=>handleUpdateThresholdsData(e,index,index_treshhold)} />
                                                            </Form.Group>
                                                            <Form.Group controlId='pds_cod' className='ms-2'>
                                                                <Form.Label>PDS COD</Form.Label>
                                                                <Form.Control className='' type='text' value={treshhold.pds_cod || ''} name='pds_cod' onChange={(e)=>handleUpdateThresholdsData(e,index,index_treshhold)} />
                                                            </Form.Group>
                                                            <Form.Group controlId='add_when_passed' className='ms-2 d-flex align-items-center'>
                                                                <Form.Check
                                                                    type='switch'
                                                                    id={`add_when_passed_${index}_${index_treshhold}`}
                                                                    name='add_when_passed'
                                                                    label={'Aggiungi se superata'}
                                                                    onChange={(e)=>handleUpdateThresholdsData(e,index,index_treshhold)}
                                                                    checked={treshhold?.add_when_passed || false}
                                                                />
                                                            </Form.Group>
                                                        </>
                                                    ) : null
                                                }
                                                {
                                                    treshhold.threshold_type === 'subject_passing_score_threshold' ? (
                                                        <Form.Group controlId='subject_id' className='ms-2'>
                                                            <Form.Label>Subject ID</Form.Label>
                                                            <Form.Control className='' type='text' value={treshhold.subject_id || ''} name='subject_id' onChange={(e)=>handleUpdateThresholdsData(e,index,index_treshhold)} />
                                                        </Form.Group>
                                                    ) : null
                                                }
                                                {
                                                    treshhold.threshold_type === 'add_to_group_threshold' ? (
                                                        <Form.Group controlId='group_id' className='ms-2'>
                                                            <Form.Label>Group ID</Form.Label>
                                                            <Form.Control className='' type='text' value={treshhold.group_id || ''} name='group_id' onChange={(e)=>handleUpdateThresholdsData(e,index,index_treshhold)} />
                                                        </Form.Group>
                                                    ) : null
                                                }
                                                <img src={trash_img} className='ms-2' onClick={()=>removeThreshold(index, index_treshhold)} />
                                                </div>
                                            )
                                        })
                                    }    
                                    
                                </div>                      
                            </div>
                        )
                    })
                }
            </div> : null }
            <ConfirmModal props={confirmModal}/>
        </>
        
    )
}